export default __webpack_public_path__ + "static/media/Events.285fe276.svg";